
import "../Page/Page.css";
import React, { useEffect, useState } from "react";
import useAPI from "../../Hooks/useAPI";

interface VdoCipherCompProps {
  filename: string;
}

const VdoCipherComp: React.FC<VdoCipherCompProps> = ({ filename }) => {
  const { getOpt } = useAPI();

  const [source, setSource] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOpt = async () => {
      try {
        const body = await getOpt(filename);

        const src = `https://player.vdocipher.com/v2/?otp=${body.otp}&playbackInfo=${body.playbackInfo}`;
        setSource(src);

        console.log("news video Response data:", body);
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
      }
    };

    fetchOpt();
  }, [filename, getOpt]);

  return (
    <div className="video-container">
      <div className="image-background">
        {source && (
          <iframe
            className="OPTVideo1"
            src={source}
            allow="encrypted-media"
            allowFullScreen   
          />
        )}
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
};

export default VdoCipherComp;